import { render, staticRenderFns } from "./Disposals.vue?vue&type=template&id=505bcb2f&scoped=true&"
import script from "./Disposals.vue?vue&type=script&lang=js&"
export * from "./Disposals.vue?vue&type=script&lang=js&"
import style0 from "./Disposals.vue?vue&type=style&index=0&id=505bcb2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505bcb2f",
  null
  
)

export default component.exports